module.exports = __webpack_public_path__ + "img/MFT白皮书_42.8c07e24d.jpg";